/**
 * Custom Log class for easy debugging
 */
export class DevLog {

    /**
     * Log message only in DEV environment
     * 
     * @param message: unknown
     * @param formatted: boolean (default = false)
     */
    static log(message:unknown, formatted = false) {
        if(process.env.NODE_ENV == 'development' && !formatted) {
            console.log(`DEV LOG | ${message}`);
        } else if (process.env.NODE_ENV !== 'production') {
            console.log(message);
        }
    }
}